import { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    name: 'index',
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        name: 'home',
        path: '',
        component: () => import('pages/DynamicIndex.vue'),
        beforeEnter: (to, from, next) => {
          // if (to.query.s) {
          //   next({ name: 'orders' });
          //   // next({ name: 'DynamicPage', query: { s: to.query.s } });
          // } else {
          //   next();
          // }
          next();
        },
      },
      { name: 'basket', path: 'basket', component: () => import('pages/Basket.vue') },
      {
        name: 'complete-order-from-basket',
        path: 'complete-order',
        component: () => import('pages/Order/CompleteOrder.vue'),
      },
      {
        name: 'complete-order',
        path: 'complete-order/:orderId',
        component: () => import('pages/Order/CompleteOrder.vue'),
      },
      {
        name: 'payment-success',
        path: 'payment-success',
        component: () => import('pages/Order/PaymentResult.vue'),
      },
      {
        name: 'payment-fail',
        path: 'payment-fail',
        component: () => import('pages/Order/PaymentResult.vue'),
      },
    ],
  },
  {
    name: 'user',
    path: '/user',
    component: () => import('layouts/UserLayout.vue'),
    children: [
      {
        name: 'main',
        path: '',
        component: () => import('pages/User.vue'),
      },
      {
        name: 'orders',
        path: 'orders',
        component: () => import('pages/User/OrderList.vue'),
      },
      {
        name: 'cancellation-or-refund',
        path: 'cancellation-or-refund',
        component: () => import('pages/User/CancellationAndRefund.vue'),
      },
      {
        name: 'membership-info',
        path: 'membership-info',
        component: () => import('pages/User/UserInfo.vue'),
      },
      {
        name: 'addresses',
        path: 'contacts',
        component: () => import('pages/User/Addresses.vue'),
      },
      {
        name: 'favourites',
        path: 'favourites',
        component: () => import('pages/User/Favourite.vue'),
      },
      {
        name: 'support',
        path: 'support',
        component: () => import('pages/User/Support.vue'),
      },
      {
        name: 'user-password',
        path: 'user-password',
        component: () => import('pages/User/Password.vue'),
      },
      {
        name: 'cancel-and-refund',
        path: 'cancel-and-refund',
        component: () => import('pages/User/CancelAndRefund/CancelAndRefund.vue'),
      },
    ],
  },
  {
    name: 'LoginAndRegister',
    path: '/login-or-register',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('pages/LoginOrRegister.vue'),
      },
    ],
  },
  {
    name: 'DynamicPage',
    path: '/:page',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('pages/DynamicPages.vue'),
      },
      {
        path: '/:page',
        component: () => import('pages/DynamicPages.vue'),
      },
    ],
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('layouts/MainLayout.vue'),
    children: [{ path: '', component: () => import('pages/DynamicPages.vue') }],
  },
];

export default routes;
